module.exports = __webpack_public_path__ + "img/amex.009e4f80.png";